import React from "react";
import { Form } from "react-bootstrap";
import Blue_btn from "../../../../../../common_components/common_btn/blue_btn/Blue_btn";
import Orange_btn from "../../../../../../common_components/common_btn/orange_btn/Orange_btn";
import { useNavigate } from "react-router-dom";

function Step10({ onNext, onBack }) {
    const navigate = useNavigate();
  return (
    <>
      <div className="mt-4 card_box">
        <div className="heading_text_holder">
          <h1>Which sentence expresses an unreal hypothesis in the past?</h1>
        </div>

        <Form className="mt-3 lt_options">
          <Form.Group className="mb-3">
            <Form.Check
              type="radio"
              name="q8"
              label="If I had known, I would have come"
              className="lt_option"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Check
              type="radio"
              name="q8"
              label="If I knew, I would come"
              className="lt_option"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Check
              type="radio"
              name="q8"
              label="If I know, I will come"
              className="lt_option"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Check
              type="radio"
              name="q8"
              label="If I had known, I would come"
              className="lt_option"
            />
          </Form.Group>
        </Form>

        {/* Buttons */}
        <div className="btn_holder">
     <Orange_btn btn_text="Back" onClick={onBack} />
        <Blue_btn btn_text="Next"  onClick={() => navigate("/portal/student/result")} />

        </div>
      </div>
    </>
  );
}

export default Step10;
